export default __webpack_public_path__ + "static/media/dashboard.92b5588a.png";